<div fxLayout="row"
     fxLayoutAlign="space-around center"
     class="timeline__timespots">
  <div fxLayout="column"
       fxLayoutAlign="center center"
       class="w-100"
       *ngFor="let step of timelineSteps">
    <div class="w-100 timeline__line timeline__line--{{step.stepValidation}} animate__animated animate__fadeIn"></div>
    <div class="timeline__timestop timeline__timestop--{{step.stepValidation}}">
      <mat-icon *ngIf="step.stepValidation === VALIDATION_STATUS.SUCCESS">
        check
      </mat-icon>
      <mat-icon *ngIf="step.stepValidation === VALIDATION_STATUS.NO_VALIDATED">
        help_outline
      </mat-icon>
      <mat-icon *ngIf="step.stepValidation === VALIDATION_STATUS.FAILED">
        close
      </mat-icon>
    </div>
    <div>{{step.stepName}}</div>
  </div>
</div>
